/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["iframe[_ngcontent-%COMP%]{width:inherit;height:inherit;min-height:330px;min-width:240px}"];
export { styles as styles };

